<template>
<div v-if="notification && notification.type === 'ERROR'">
  <p><span></span>{{ error }}</p>
</div>
</template>

<script>
  import { mapGetters } from 'vuex';


export default {
  name: 'NotificationError',
  computed: {
    ...mapGetters(['notification']),
    error() {
      return this.notification.error;
    },
  }
}
</script>

<style scoped>
div {
  font-size: 0.9em;
  margin-top: 10px;
  padding: 0.7em;
  border: 1px solid #fe9077;
  background: #db4c4c;
  border-radius: 6px;
  color: #ffffff;
}

p {
  font-size: 10.8px;
}

span {
  float: left;
  margin-right: 0.3em;
  width: 16px;
  height: 16px;
  display: block;
  text-indent: -99999px;
  overflow: hidden;
  background: url(../../../assets/ui-icons_ffffff_256x240.png) no-repeat 0 -144px;
  color: #ffffff;
}
</style>


